import { toStartDate, toEndDate } from '@/helpers/date.js'

export const isIntervalInTimeframe = (interval, timeframe) => (
  new Date(toStartDate(interval)).valueOf() >= new Date(toStartDate(timeframe.start)).valueOf() &&
  new Date(toEndDate(interval)).valueOf() <= new Date(toEndDate(timeframe.end)).valueOf()
)
